import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { useCanLoadQuote } from "../../../flow/SideSheetFlows/SwapFlow/provider/use-can-load-quote";
import { roundToken } from "../../../lib/tokens";
export function useCurrencyInputValues(t0) {
  const $ = _c(16);
  const {
    currency,
    usdValue,
    quantity,
    direction,
    isLoading
  } = t0;
  const [prevQuantity, setPrevQuantity] = useState(0);
  const [prevUsdTotal, setPrevUsdTotal] = useState(0);
  const isCanLoadQuote = useCanLoadQuote();
  const isFrom = direction === "from";
  currency?.usdPrice;
  let t1;
  bb0: {
    if (quantity && currency?.usdPrice) {
      t1 = quantity * Number(currency.usdPrice);
      break bb0;
    }
    t1 = 0;
  }
  const usdTotalFallback = t1;
  const usdTotal = usdValue || usdTotalFallback;
  const isUsePreviousQuantity = isLoading || !quantity && isCanLoadQuote;
  const isUsePreviousUsdTotal = isLoading || !usdTotal && isCanLoadQuote;
  const currentQuantity = isUsePreviousQuantity ? prevQuantity : quantity;
  const currentUsdTotal = isUsePreviousUsdTotal ? prevUsdTotal : usdTotal;
  let t2;
  let t3;
  if ($[0] !== currentQuantity || $[1] !== isFrom) {
    t3 = isFrom ? currentQuantity : roundToken(currentQuantity);
    $[0] = currentQuantity;
    $[1] = isFrom;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  t2 = t3;
  const quantityValue = t2;
  let t4;
  let t5;
  if ($[3] !== currentUsdTotal || $[4] !== isFrom) {
    t5 = isFrom ? currentUsdTotal : roundToken(currentUsdTotal);
    $[3] = currentUsdTotal;
    $[4] = isFrom;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  t4 = t5;
  const usdTotalValue = t4;
  let t6;
  let t7;
  if ($[6] !== quantity || $[7] !== usdTotal) {
    t6 = () => {
      if (quantity) {
        setPrevQuantity(quantity);
      }
      if (usdTotal) {
        setPrevUsdTotal(usdTotal);
      }
    };
    t7 = [quantity, usdTotal];
    $[6] = quantity;
    $[7] = usdTotal;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[10] !== isCanLoadQuote) {
    t8 = () => {
      if (!isCanLoadQuote) {
        setPrevQuantity(0);
        setPrevUsdTotal(0);
      }
    };
    t9 = [isCanLoadQuote];
    $[10] = isCanLoadQuote;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  useEffect(t8, t9);
  let t10;
  if ($[13] !== quantityValue || $[14] !== usdTotalValue) {
    t10 = {
      quantityValue,
      usdTotalValue
    };
    $[13] = quantityValue;
    $[14] = usdTotalValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}